async function checkServerAuthStatus() {
  try {
    const response = await fetch("/wp-admin/admin-ajax.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: "action=check_auth",
    });
    const data = await response.json();
    return data.isLoggedIn;
  } catch (error) {
    console.error("Auth check failed:", error);
    return false;
  }
}

export async function checkAuthStatus() {
  const isAuthenticated = await checkServerAuthStatus();
  if (!isAuthenticated && window.isLoggedIn) {
    window.isLoggedIn = false;
    window.location.reload();
  }
}

export function initAuthCheck() {
  window.isLoggedIn = document.body.classList.contains("logged-in");
  setInterval(checkAuthStatus, 60000);
}
